/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Plan_Build_Organize_DownInputs */

const en_us2_plan_build_organize_down = /** @type {(inputs: Plan_Build_Organize_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.session} down`)
};

const pt_br2_plan_build_organize_down = /** @type {(inputs: Plan_Build_Organize_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descer ${i?.session}`)
};

const es_419_plan_build_organize_down = /** @type {(inputs: Plan_Build_Organize_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bajar ${i?.session}`)
};

const pt_pt2_plan_build_organize_down = /** @type {(inputs: Plan_Build_Organize_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descer ${i?.session}`)
};

const fr_fr2_plan_build_organize_down = /** @type {(inputs: Plan_Build_Organize_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descendre ${i?.session}`)
};

const de_de2_plan_build_organize_down = /** @type {(inputs: Plan_Build_Organize_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} nach unten`)
};

const it_it2_plan_build_organize_down = /** @type {(inputs: Plan_Build_Organize_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sposta ${i?.session} in giù`)
};

/**
* | output |
* | --- |
* | "Move {session} down" |
*
* @param {Plan_Build_Organize_DownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize_down = /** @type {((inputs: Plan_Build_Organize_DownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Organize_DownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize_down(inputs)
	if (locale === "es-419") return es_419_plan_build_organize_down(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize_down(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize_down(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize_down(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize_down(inputs)
	return en_us2_plan_build_organize_down(inputs)
});
export { plan_build_organize_down as "plan-build.organize_down" }